// Как се получава следващият номер на фактура — на ЕДНО място.
//
// Ползва се от два екрана: прегледът в „Номерация на документи“ (Конфигурация
// → Фирми) и полето, с което тръгва модалът за фактуриране в „Маркиране“.
// Докато формулата беше преписана и на двете места, всяка промяна тук трябваше
// да се сети и там — а разминаването се вижда чак върху издаден документ.

/** Дължината, до която BE-то допълва номера с водещи нули. */
export const INVOICE_NUMBER_LENGTH = 10;

/**
 * Следващият номер след `lastNumber`, като низ с водещи нули.
 * `null`/`undefined` се чете като „още няма издадена фактура“ → номер 1.
 */
export const nextInvoiceNumberOf = (
  lastNumber: number | null | undefined,
): string => String((lastNumber ?? 0) + 1).padStart(INVOICE_NUMBER_LENGTH, "0");

/** Номерата, които вдигането на „Последен номер на фактура“ обявява за вече
 *  издадени (от фискалното устройство). */
export type SkippedInvoiceNumbers = { count: number; from: string; to: string };

/**
 * Какво прескача записът в ЖИВА обща поредица (`minimum` — броячът ѝ; null —
 * поредицата не е жива и номерът е на клиента). Вдигнатите номера облакът
 * повече не дава, а BE не връща брояча надолу — една цифра в повече (1730
 * вместо 173) е пропуск завинаги, затова записът иска потвърждение.
 */
export const skippedInvoiceNumbersOf = (
  minimum: number | null,
  lastNumber: number | null,
): SkippedInvoiceNumbers | null => {
  if (minimum === null || lastNumber === null || lastNumber <= minimum) return null;
  return {
    count: lastNumber - minimum,
    from: nextInvoiceNumberOf(minimum),
    to: String(lastNumber).padStart(INVOICE_NUMBER_LENGTH, "0"),
  };
};
